import React from 'react';
import { Avatar } from '../avatar/avatar';
import { JobIndicatorPreview } from '../jobIndicatorPreview/JobIndicatorPreview';

import stylesJob from '../jobIndexCard/JobForm.module.scss';
import classNames from 'classnames';

import styles from './JobLabel.module.scss';
import { Badge } from 'reactstrap';
import { appUrl } from '@constants/baseUrl';

export const JobLabel = (props) => {
  const {
    colors,
    client,
    clientLogo,
    job,
    size = 50,
    showClient = true,
    titleLink = false,
    className,
    classIndicator,
    onClientClick,
  } = props;
  
  // Helper: build slug from client name only (preferred)
  const getClientDisplayName = () => client || job?.client_name || job?.client?.name;
  const getClientSlug = () => {
    // Prefer explicit slug fields from API over generated slug
    const explicitSlug = job?.client?.slug 
      || job?.client_slug 
      || job?.client?.slug_full 
      || job?.client?.id_slug 
      || job?.client?.slugged_name;
    if (explicitSlug) return explicitSlug;
    const name = getClientDisplayName();
    if (!name) return '';
    return name
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
  };
  
  return (
    <>
      <div className={classNames(styles.parentWrapper)}>
        <div className={classNames(styles.iconContainer)}>
          <div
            onClick={() => {
              const clientSlug = getClientSlug();
              if (clientSlug) window.location.href = `${appUrl}/company/${clientSlug}`;
            }}
            style={{ cursor: 'pointer' }}
          >
            <Avatar
              name={job?.title}
              size={size}
              src={job?.logo}
              style={{
                zIndex: '2',
                display: 'inline-block',
                float: 'left',
                position: 'relative',
              }}
              className={classNames(className)}
            />
          </div>
          <div>
            <JobIndicatorPreview
              className={classIndicator}
              acronym={job?.indicator_acronym || job?.acronym}
              colors={colors}
              color_id={job?.colour_id}
              style={{ cursor: 'pointer' }} // added for interactivity
              onClick={() => window.location.href = `${appUrl}/jobs/${job?.id}`}
            />
          </div>
        </div>

        <div className={classNames(styles.titleContainer)}>
          <div
            className={classNames(
              stylesJob.inputTitle,
              { [styles.titleLink]: titleLink },
              'me-2 mb-0',
            )}
            onClick={titleLink}
            title={job?.name}
          >
            {job?.title}
          </div>
          {showClient && (getClientDisplayName() || job?.company_name || job?.company?.name) && (
            <div className={styles.clientName}>
              {onClientClick ? (
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    const cid = job?.client_id || job?.client?.id;
                    if (cid) onClientClick(cid);
                  }}
                  style={{
                    appearance: 'none',
                    background: 'transparent',
                    border: 'none',
                    padding: 0,
                    margin: 0,
                    cursor: 'pointer',
                    color: '#9aa3af',
                    fontSize: '13px',
                    fontWeight: 500,
                    textDecoration: 'none'
                  }}
                >
                  {getClientDisplayName() || job?.company_name || job?.company?.name}
                </button>
              ) : (
                <a 
                  href={`${appUrl}/company/${(() => {
                    const clientSlug = getClientSlug();
                    if (clientSlug) return clientSlug;
                    if (job?.company?.slug) return job.company.slug;
                    const fallbackName = job?.company_name || job?.company?.name || '';
                    return fallbackName.toLowerCase().trim().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
                  })()}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  {getClientDisplayName() || job?.company_name || job?.company?.name}
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};
